module.exports = __webpack_public_path__ + "static/media/Rayos-min.851ee264.png";